import React from "react";
import { LazyLoadImages } from "@quintype/components";
import { SectionPage as SectionPageBase } from "../components/pages/section";
import { TagPage as TagPageBase } from "../components/pages/tag";
import { AuthorPage as AuthorPageBase } from "../components/pages/author";
import { SearchPage as SearchPageBase } from "../components/pages/search";
import { CatalogPage as CatalogPageBase } from "../components/pages/catalog";
import { HomePagePreview as HomePagePreviewBase } from "../components/pages/home-preview";
import { NotFoundPage as NotFoundPageBase } from "../components/pages/not-found";
import { BundlePage as BundlePageBase } from "../components/pages/bundle";
import { MagazineLandingPage as MagazineLandingPageBase } from "../components/pages/magazine-landing";
import { MagazineIssueListingPage as MagazineIssueListingPageBase } from "../components/pages/magazine-listing-page";
import { MagazineSearchArchivePage as MagazineSearchArchivePageBase } from "../components/pages/magazine-archive-page";
import { MagazineLandingPageBundle as MagazineLandingPageBundlePageBase } from "../components/pages/magazine-landing-bundle";
import { IplPage as IplPageBase } from "../components/pages/ipl";
import { WebstoriesPage as WebstoriesPageBase } from "../components/pages/webstories-page";
import { VikatanSeriesPage as VikatanSeriesPageBase } from "../components/pages/vikatan-series-page";
import { ViBundlePage as ViBundlePageBase } from "../components/pages/collection-webstories";
import { SeriesLandingPage as SeriesLandingPageBase } from "../components/pages/vikatan-series-bundle";
import { VideoPage as VideoPageBase } from "../components/pages/video-page";

import { VikatanSectionHeader } from "../components/rows/ad-free";

function wrapLazyLoadImages(Template) {
  const ImageLazyLoadedComponent = props => {
    return (
      <React.Fragment>
        <VikatanSectionHeader />
        <LazyLoadImages margin={"150px"}>
          <Template {...props} />
        </LazyLoadImages>
      </React.Fragment>
    );
  };
  ImageLazyLoadedComponent.displayName = `WrapLazyLoadImages(${Template.name})`;
  return ImageLazyLoadedComponent;
}

export const SectionPage = wrapLazyLoadImages(SectionPageBase);
export const TagPage = wrapLazyLoadImages(TagPageBase);
export const AuthorPage = wrapLazyLoadImages(AuthorPageBase);
export const SearchPage = wrapLazyLoadImages(SearchPageBase);
export const CatalogPage = wrapLazyLoadImages(CatalogPageBase);
export const HomePagePreview = wrapLazyLoadImages(HomePagePreviewBase);
export const NotFoundPage = wrapLazyLoadImages(NotFoundPageBase);
export const BundlePage = wrapLazyLoadImages(BundlePageBase);
export const MagazineLandingPage = wrapLazyLoadImages(MagazineLandingPageBase);
export const MagazineLandingPageBundlePage = wrapLazyLoadImages(MagazineLandingPageBundlePageBase);
export const IplPage = wrapLazyLoadImages(IplPageBase);
export const WebstoriesPage = wrapLazyLoadImages(WebstoriesPageBase);
export const VikatanSeriesPage = wrapLazyLoadImages(VikatanSeriesPageBase);
export const ViBundlePage = wrapLazyLoadImages(ViBundlePageBase);
export const SeriesLandingPage = wrapLazyLoadImages(SeriesLandingPageBase);
export const VideoPage = wrapLazyLoadImages(VideoPageBase);
export const MagazineIssueListingPage = wrapLazyLoadImages(MagazineIssueListingPageBase);
export const MagazineSearchArchivePage = wrapLazyLoadImages(MagazineSearchArchivePageBase);
